export function libraryQueryScore(
	query: string | undefined,
	...values: Array<string | undefined | null>
): number {
	const needle = query?.trim().toLowerCase();
	if (!needle) {
		return 1;
	}

	return values.some((value) => (value ?? '').toLowerCase().includes(needle)) ? 1 : 0;
}

export function localizedSearchText(value?: Array<{ text?: string | null }> | null): string {
	return (value ?? []).map((entry) => entry.text ?? '').join(' ');
}
